module.exports = __webpack_public_path__ + "static/media/IconRight.83e06ca1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/intra-section/img/IconRight.svg
// module id = 956
// module chunks = 1